import React from 'react';

interface Props {
  title: string;
  value: string;
  subtext: string;
  onClick?: () => void; // Optional
}

const MetricCard: React.FC<Props> = ({ title, value, subtext, onClick }) => (
  <div className="cards" onClick={onClick} style={{ cursor: 'pointer' }}>
    <h2>{title}</h2>
    <h3>{value}</h3>
    <p>{subtext}</p>
  </div>
);

export default MetricCard;
